import { Form } from 'formik'
import { FC, PropsWithChildren, ReactElement, useState } from 'react'
import { useTranslation } from 'next-i18next'
import AnimateHeight from 'react-animate-height'
import styles from './index.module.scss'
import { KeywordSearchGroupFormSearchButton } from '../KeywordSearchGroupFormSearchButton'

type Props = {
  renderPrimaryForm: () => ReactElement
  isSubmitting: boolean
}

export const KeywordSearchGroupForm: FC<PropsWithChildren<Props>> = ({ children, renderPrimaryForm, isSubmitting }) => {
  const { t } = useTranslation(['angels-vcs-startups'])
  const [isOpenDropDown, setIsOpenDropDown] = useState(false)
  const toggleDropDown = () => {
    setIsOpenDropDown(!isOpenDropDown)
  }
  return (
    <Form>
      <div className={styles.keywordContainer}>{renderPrimaryForm()}</div>
      <AnimateHeight duration={300} height={isOpenDropDown ? 'auto' : 0} easing='ease'>
        <div className={styles.advancedSearchContainer}>
          <p className={styles.label}>{t('詳細検索')}</p>
          {children}
        </div>
      </AnimateHeight>
      <KeywordSearchGroupFormSearchButton
        isSubmitting={isSubmitting}
        isOpenDropDown={isOpenDropDown}
        toggleDropDown={() => toggleDropDown()}
      />
    </Form>
  )
}
